<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div align="center">
      <p>确认退出小区，退出后不可恢复!</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeStoreExitCommunityModal">点错了</el-button>
      <el-button type="primary" @click="deleteExitCommunity">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { exitCommunity } from '@/api/common/enterCommunity/enterCommunityApi'

export default {
  name: 'StoreExitCommunity',
  data() {
    return {
      dialogVisible: false,
      communityInfo: {}
    }
  },
  methods: {
    open(communityInfo) {
      this.communityInfo = communityInfo
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    closeStoreExitCommunityModal() {
      this.dialogVisible = false
    },
    async deleteExitCommunity() {
      try {
        await exitCommunity(this.communityInfo)
        this.$emit('refresh')
        this.dialogVisible = false
      } catch (error) {
        console.error('退出小区失败:', error)
        this.$message.error('退出小区失败')
      }
    }
  }
}
</script>